module.exports = __webpack_public_path__ + "img/result.ed34da75.svg";